import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index.js";
import routes from "./routes.js";
import { onHttpEvent } from "../api/http.js";

const SITE_NAME = "IBACY Net";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

const requiredPermissions = (route) => {
  const permissions = route.matched.map((record) => record.meta.permission).filter(Boolean).flat();
  return permissions;
};

router.beforeEach(async (to) => {
  document.title = to.meta.title ? `${to.meta.title} · ${SITE_NAME}` : SITE_NAME;

  const isPublic = to.matched.some((record) => record.meta.public);
  const authenticated = await store.dispatch("auth/ensureSession");

  if (to.meta.guestOnly && authenticated) {
    return { name: store.getters["auth/mustChangePassword"] ? "changePassword" : "dashboard" };
  }

  if (isPublic) {
    return true;
  }

  if (!authenticated) {
    return { name: "login", query: to.fullPath !== "/" ? { redirect: to.fullPath } : {} };
  }

  if (store.getters["auth/mustChangePassword"] && !to.meta.allowPasswordChange) {
    return { name: "changePassword" };
  }

  const permissions = requiredPermissions(to);
  if (permissions.length && !store.getters["auth/hasAnyPermission"](permissions)) {
    return { name: "forbidden" };
  }

  return true;
});

// Réactions globales aux réponses de l'API.
onHttpEvent((type) => {
  const current = router.currentRoute.value;

  if (type === "unauthenticated" && !current.meta.public) {
    store.commit("auth/clearUser");
    router.replace({ name: "login", query: { expired: 1 } });
  }

  if (type === "locked") {
    store.commit("auth/setLocked", true);
  }

  if (type === "password-change") {
    store.commit("auth/setMustChangePassword", true);
    router.replace({ name: "changePassword" });
  }
});

export default router;
